/**
 * Sign Up Route
 * Public route for user registration
 */

import { useEffect } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { SignUpPage } from '../pages/Auth/SignUpPage'
import { requireGuest } from '../router/guards'
import { rememberPlanIntent } from '../utils/planIntent'

const SignUpRouteComponent = () => {
  const navigate = useNavigate()
  const { plan } = useSearch({ from: '/signup' })

  useEffect(() => {
    rememberPlanIntent(plan)
  }, [plan])

  return (
    <SignUpPage
      onLogin={() => navigate({ to: '/login' })}
      onForgotPassword={(email) => navigate({ to: '/forgot-password', search: { email } as never })}
    />
  )
}

// Create signup route with guest guard
export const Route = createFileRoute('/signup')({
  validateSearch: (search: Record<string, unknown>): { plan?: string } =>
    typeof search.plan === 'string' ? { plan: search.plan } : {},
  beforeLoad: requireGuest,
  component: SignUpRouteComponent,
})
